<template>
    <main-content with_go_back_bar>
        <div class="tab-content">
            <div class="tab-pane active" id="questions">
                <questions></questions>
            </div>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import questions from './components/questions'
export default {
    data() {
        return {
            active_pane: '#important_tickets',
            cat_hashid: this.$route.params.hashid
        }
    },
    components: {
        mainContent,
        questions
    }
}
</script>

<style scoped>
.kt-portlet {
    margin-bottom: 1px !important;
}
</style>